<template>
    <div id="footerDiv" v-if="(foot)">
        <div class="copy-rights text-center pt-2 pb-2" v-if="!isApp">
            <p class="m-0">2017 labotist . All rights reserved.</p>
        </div> 
    </div>
</template>

<script>
export default {
  name: 'FooterVue',
  props: ['foot'],
  beforeCreate () { },
  data () {
    return {
      newsLetterEmail: '',
      isApp: this.$WebView
    }
  },
  methods: {
    saveNewsLetter: function () {
      this.$validator.validateAll('newsletter').then((result) => {
        if (result) {
          try {
            var data = {
              email: this.newsLetterEmail
            }
            Promise.resolve(this.$POST('patient/newsSubscriber', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$Simplert.open({
                  title: 'Success',
                  message: `Thanks for signup newsletter`,
                  type: 'success',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false
                })
                // alert('Thanks for signup newsletter')
              } else {
                this.$Simplert.open({
                  message: res.response_message,
                  type: 'success',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false
                })
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          } catch (e) {
            console.error(e)
          }
        }
      }).catch(() => {
        console.log('error exist while save news letter', this.errors)
      })
    }
  },
  created () {
    setTimeout(function () {
      if(this.$WebView) {
        this.isApp = this.$WebView
      } else {
        setTimeout(function () {
          this.isApp = this.$WebView
        }.bind(this), 2000)
     }
    }.bind(this), 2000)
    let rootpath = this.$route.fullPath.split('/')
    if(rootpath[1] === 'appointment' ||  rootpath[1] === 'address' || rootpath[1] === 'lab' || rootpath[1] === 'labs' || rootpath[1] === 'payment') {
      setTimeout(function(){
        var footerHeight = $('#fixed-footer').outerHeight();
        $('body').css('padding-bottom', footerHeight + 15);
        if(rootpath[1] === 'lab' || rootpath[1] === 'labs') {
                var footerHeightPopup = $('#fixed-footer').outerHeight();
            $('.test-search-popup').css('padding-bottom', footerHeightPopup - 15);
        }
      },500)
    }else {
      setTimeout(function(){
        $('body').css('padding-bottom', '');
        $('.test-search-popup').css('padding-bottom', '');
      },500)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.help.is-danger {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Footer.vue